import { HostingTab } from '@pages/Hosting/Show';

export const resolveHostingTabTitle = (tab: string) => {
  const items = {
    [HostingTab.info]: 'Информация о хостинге',
    [HostingTab.clients]: 'Клиенты',
  };

  // @ts-ignore
  return items[tab];
};
